import React from "react";

/**
 * LightSource — a single point of light at the top-center of the viewport
 * with a thin white→gold cascade falling down. Symbolic of "the light in the
 * darkness". CSS-only, GPU-friendly, non-interactive.
 *
 *  ╶── core (small radial glow)
 *      │
 *      │   thin vertical line (white → gold → fade)
 *      │
 *      ▼
 */
export default function LightSource() {
  return (
    <div
      className="light-source pointer-events-none"
      aria-hidden="true"
      data-testid="light-source"
    >
      <div className="light-source__halo" />
      <div className="light-source__core" />
      <div className="light-source__trail" />
    </div>
  );
}
